import {
  DeleteTemplateMessageSuggestion,
  DeleteTemplateMessageSuggestionVariables
} from './__generated__/DeleteTemplateMessageSuggestion'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteTemplateMessageSuggestion($id: String!) {
    deleteTemplateMessageSuggestion: deleteTemplateMessageSuggestionV2(id: $id) {
      ... on TemplateMessageSuggestionV2 {
        id
        created
        message {
          id
          characters
          text
        }
      }
      ... on TemplateMessageSuggestionErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteTemplateMessageSuggestion = () =>
  useMutation<DeleteTemplateMessageSuggestion, DeleteTemplateMessageSuggestionVariables>(MUTATION)
